import { render, staticRenderFns } from "./CaseNotes.vue?vue&type=template&id=09c53029&scoped=true&"
import script from "./CaseNotes.vue?vue&type=script&lang=js&"
export * from "./CaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./CaseNotes.vue?vue&type=style&index=0&id=09c53029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c53029",
  null
  
)

export default component.exports